import { Component, OnInit, EventEmitter } from '@angular/core';
import { SessionService, HttpService, MessageService, FunctionsService, fileInputParams, FileFormsService, TableConfiguration, TableColumns, fileFormsParams, CombosConfiguration, params, LocalStorageService, MenuBreadCrumb } from 'brainloper-ui';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { UntypedFormControl } from '@angular/forms';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { default as _rollupMoment } from 'moment';
import * as _moment from 'moment';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { Equipment } from 'app/models2/maintenance/equipment';
import { ComponentEquipment } from 'app/models2/maintenance/component';
import { EquipmentService } from 'app/services/equipment.service';
import { ModalTypesComponent } from 'app/components/shared/modals-types/modal-types.component';
import { ModalEquipmentComponent } from '../modal-equipment/modal-equipment.component';
import { MatSelectChange } from '@angular/material/select';
import { GenericResponse } from 'app/models2/commos/generic-response';
import { BaseResponse } from 'app/models2/commos/base-response';
import { DeleteGenericService } from 'app/services/delete-generic.service';


const moment = _rollupMoment || _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-equipment-detail',
  templateUrl: './equipment-detail.component.html',
  styleUrls: ['./equipment-detail.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class EquipmentDetailComponent implements OnInit {

  public tipoRedireccion: string
  public numeroComponentes: Array<number> = []
  private dataEquipo: Equipment
  public filteredList
  public date = new UntypedFormControl(moment());


  public movil: boolean
  private file = null

  private fileOld: fileFormsParams[] = [{
    id: 'old',
    value: ''
  }]

  private urlGetAreas: string = `${EndpointDictionary.Area.AREA_COMBO}`
  private urlPostEquipos: string = `${EndpointDictionary.Equipment.CRUD_EQUIPMENT_DATA}`
  private urlPostComponentes: string = `${EndpointDictionary.ComponentEquipment.CRUD_COMPONENT_EQUIPMENT_DATA}`
  public urlGetComponentes: string = `${EndpointDictionary.ComponentEquipment.COMPONENT_EQUIPMENT_TABLE}`
  private urlComboEquipmentType: string = `${EndpointDictionary.EquipmentType.EQUIPMENT_TYPE_COMBO}`
  private urlComboUsuarios: string = `${EndpointDictionary.User.USER_COMBO}`
  private inactivateEquipment: string = `${EndpointDictionary.Equipment.INACTIVATE_EQUIPMENT}`;
  private activeEquipment: string = `${EndpointDictionary.Equipment.ACTIVE_EQUIPMENT}`;

  public formEquipos: UntypedFormGroup
  public formComponentes: Array<ComponentEquipment> = []

  public reloadComboArea = new EventEmitter<any>()
  public combosConfigArea: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'id',
    urlCombo: this.urlGetAreas,
    urlParams: [],
    label: 'Area'
  }
  public reloadComboEquipmentType = new EventEmitter<any>()
  public combosConfigEquipmentType: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'id',
    urlCombo: this.urlComboEquipmentType,
    urlParams: [],
    label: 'Tipo de Equipo'
  }

  public reloadComboResponsable = new EventEmitter<any>()
  public combosConfigResponsable: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'userId',
    urlCombo: this.urlComboUsuarios,
    urlParams: [],
    label: 'Responsable'
  }

  public buttonEnd: boolean = false
  //imagen
  public fileInputEquipo: fileInputParams = {
    typeFile: "imagen",
    input: "formulario",
    label: "imagen",
    edit: true,
    style: {
      width: '100%'
    }
  }

  //Component table

  public paramsCompoentes: params[] = [
    {
      id: 'equipmentId',
      value: this.session.getData('equipment').id
    }
  ]

  public titleComponentes = screen.width > 450 ? 'Componentes' : ''
  recargarTablaComponentes = new EventEmitter<any>()
  public dataComponentes: ComponentEquipment[] = []
  public configurationComponentes: TableConfiguration = {
    edit: screen.width > 450 ? true : false,
    add: screen.width > 450 ? true : false,
    delete: screen.width > 450 ? true : false,
    selectable: screen.width > 450 ? true : false,
    addPer: screen.width > 450 ? true : false,
    editPer: screen.width > 450 ? true : false,
    primaryKey: 'id'
  }
  public columnasComponentes: TableColumns<ComponentEquipment>[] = [
    {
      ID: 'name',
      label: 'Nombre',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'specifications',
      label: 'Especificaciones',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    }
  ]

  constructor(
    private session: SessionService,
    private http: HttpService,
    private message: MessageService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    public dialog: MatDialog,
    private functionsEter: FunctionsService,
    private formFile: FileFormsService,
    private equipmentService: EquipmentService,
    private deleteService: DeleteGenericService


  ) {
    this.formEquipos = this.formBuilder.group({
      userId: null,
      code: null,
      areaId: null,
      fabricationDate: null,
      brand: null,
      color: null,
      providerName: null,
      warranty: null,
      power: null,
      powerSupply: null,
      purchaseDate: null,
      accessories: null,
      description: null,
      aplication: null,
      serial: null,
      photo: null,
      id: null,
      equipmenTypeId: null,
      currentOdometer: null,
      rentalCost: null,
      isRental: 0
    })

  }

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: "Inicio",
      router: '/inicio',
    },
    {
      name: "Equipos",
      router: '/mantenimiento/equipos',
    },
    {
      name: "Detalle",
      current: true
    }]

  async ngOnInit() {
    this.message.openLoading('Cargando', 'Cargando Información')
    this.tipoRedireccion = this.session.getData('redireccion')
    this.cargarCombos()
    this.movil = screen.width > 600 ? false : true

    if (this.tipoRedireccion == 'update') {
      await this.inicializarCampos()
    }
  }

  async inicializarCampos() {

    this.dataEquipo = this.session.getData('equipment')
    this.fileInputEquipo.label = this.dataEquipo.photo
    this.fileOld[0]['value'] = this.dataEquipo.photo

    for (let controls of Object.keys(this.formEquipos.controls)) {
      if (this.dataEquipo[controls]) {
        this.formEquipos.controls[controls].setValue(this.dataEquipo[controls])
      }
    }
    this.dataEquipo.purchaseDate = this.dataEquipo.purchaseDate ? this.functionsEter.dateIso(this.dataEquipo.purchaseDate) : null

    this.message.closeLoading()
  }

  chosenYearHandler(date: string) {
    this.formEquipos.controls.fabricationDate.setValue(date)
  }

  cargarCombos() {
    if (this.tipoRedireccion == 'new') {
      this.message.closeLoading()
    }
    this.numeroComponentes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
  }

  numberComponent() {

    //this.numeroComponentes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

    this.formComponentes = [
      { name: 'Sistema Eléctrico', specifications: '', photo: '' },
      { name: 'Sistema de admisión y escape', specifications: '', photo: '' },
      { name: 'Sistema de lubricación', specifications: '', photo: '' },
      { name: 'Sistema de alimentación inyección', specifications: '', photo: '' },
      { name: 'Sistema de refrigeracio', specifications: '', photo: '' },
      { name: 'Sistema de suspensión', specifications: '', photo: '' },
      { name: 'Sistema de direcion y frenos', specifications: '', photo: '' },
      { name: 'Sistema de transmisión y puentes', specifications: '', photo: '' },
      { name: 'Sistema estructural', specifications: '', photo: '' },
      { name: 'Otro', specifications: '', photo: '' }
    ]

  }


  fileSaveEquipo($event) { //new: file
    if ($event.compressor) {
      this.file = $event.compressor
    } else {
      this.file = $event.new
    }
  }

  async saveEquipo(form: Equipment) {

    this.buttonEnd = true
    let equipmentId: number = 0
    form.purchaseDate = form.purchaseDate ? this.functionsEter.dateForm(form.purchaseDate) : null

    if (this.tipoRedireccion == 'new') {
      this.message.openLoading('Cargando', 'Guardando Equipo')

      //Add Equipo

      if (this.file == null) {
        console.log('no se agrego imagen')
      } else {
        let formImg = this.formFile.createMultipartForm(this.file)
        let res: string = await this.http.postDataBody(`${EndpointDictionary.Docs.DOCS_SUBIR}`, formImg)
        form.photo = res
      }


      let res: GenericResponse = await this.http.postDataBody(`${this.urlPostEquipos}`, form)
      //console.log(res)
      if (res) {
        equipmentId = res.insertId
        if (this.formComponentes.length == 0) {
          this.message.closeLoading()
          this.message.SuccessToast('Equipo creado correctamente')
          setTimeout(() => {
            this.router.navigate(['mantenimiento/equipos'])
          }, 500);
        } else {
          console.log('agredando componentes ...')
          this.addComponents(equipmentId)

        }
      }


    } else {
      this.message.openLoading('Cargando', 'Actualizando Equipo')
      //Actualizar equipo

      if (this.file == null) {
        console.log('no se actualizo imagen')
        form.photo = this.fileInputEquipo.label
      } else {
        let formImg = this.formFile.createMultipartForm(this.file, this.fileOld)
        let res: string = await this.http.postDataBody(`${EndpointDictionary.Docs.DOCS_SUBIR}`, formImg)
        form.photo = res
      }

      form.id = this.session.getData('equipment').id
      let res: GenericResponse = await this.http.putDataBody(`${this.urlPostEquipos}`, form)

      if (res) {
        this.message.closeLoading()
        this.message.SuccessToast('Equipo actualizado correctamente')
        setTimeout(() => {
          this.router.navigate(['mantenimiento/equipos'])
        }, 1000);
      }
    }
  }

  async addComponents(equipmentId: number) {

    var formComponentes: ComponentEquipment = {
      name: '',
      specifications: '',
      photo: '',
      equipmentId: equipmentId
    }

    if (formComponentes.equipmentId > 0 && this.formComponentes.length > 0) {

      //Agregar Componentes
      var i = 0
      for (let element of this.formComponentes) {
        i = i + 1

        formComponentes.name = element.name
        formComponentes.specifications = element.specifications
        formComponentes.photo = element.photo

        try {
          let res: GenericResponse = await this.http.postDataBody(`${this.urlPostComponentes}`, formComponentes)
          if (res) {
            console.log('componente agregado')
          }
        } catch (error) {
          this.message.Error('Error', `${error}`)
        }
      }
      if (i == this.formComponentes.length) {
        setTimeout(() => {
          this.message.closeLoading()
          this.message.SuccessToast('Equipo creado correctamente')
          this.router.navigate(['mantenimiento/equipos'])
        }, 1000);
      }


    } else {
      this.message.closeLoading()
      this.message.SuccessToast('Equipo creado correctamente')
      setTimeout(() => {
        this.router.navigate(['mantenimiento/equipos'])
      }, 500);
    }
  }


  errorMessage() {
    this.message.Error('Error', 'complete los campos')

  }
  async deleteEquipo($event) {
    $event.preventDefault()
    let arrayDelete: Array<Equipment> = []
    arrayDelete.push(this.dataEquipo)
    let res = await this.deleteService.inactivateOrActivate(arrayDelete, false, this.activeEquipment, this.inactivateEquipment, 'Equipo')

    if (res) {
      this.router.navigate(['mantenimiento/equipos'])
    }

  }

  addNew(type) {
    //console.log(type)

    let size: number = screen.width > 500 ? 60 : 50

    const dialogRef = this.dialog.open(ModalTypesComponent, {
      width: `${size}vh`,
      data: { name: type }
    });

    dialogRef.afterClosed().subscribe(result => {
      switch (type) {
        case 'tipo de equipo':
          this.reloadComboEquipmentType.emit()
          break;
        case 'area':
          this.reloadComboArea.emit()
          break;
      }
    });

  }

  back($event) {
    $event.preventDefault()
    setTimeout(() => {
      this.router.navigate(['mantenimiento/equipos'])
    }, 500);

  }

  agregarComponentes($event: ComponentEquipment) {
    //console.log($event)

    let sizeW: number = screen.width > 800 ? 40 : 90
    let sizeH: number = screen.height > 500 ? 55 : 90

    this.dialog.open(ModalEquipmentComponent, {
      width: `${sizeW}%`,
      height: `${sizeH}%`,
      data: {
        action: 'addComponente'
      }
    }).afterClosed().subscribe(res => {
      //console.log("respuestaa",res)
      this.message.closeLoading()
      this.recargarTablaComponentes.emit()
      this.inicializarCampos()
    })

  }

  editarComponentes($event: ComponentEquipment) {
    //console.log($event)

    let sizeW: number = screen.width > 800 ? 40 : 90
    let sizeH: number = screen.height > 500 ? 55 : 90

    this.dialog.open(ModalEquipmentComponent, {
      width: `${sizeW}%`,
      height: `${sizeH}%`,
      data: {
        action: 'editComponente',
        componentId: $event[0].id
      }
    }).afterClosed().subscribe(res => {
      this.message.closeLoading()
      this.recargarTablaComponentes.emit()
      this.inicializarCampos()
    })
  }

  eliminarComponentes($event) {
    //console.log($event)
    let cuanti: string
    if ($event.length == 1) {
      cuanti = 'Desea eliminar componente'
    } else {
      cuanti = 'Desea eliminar componentes'
    }

    this.message.Warning(cuanti, ``, true).then(
      (res: boolean) => {


        if (res == true) {
          this.message.openLoading('Cargando', 'Eliminando Componente')
          $event.forEach(data => {
            this.http.deleteData(`${this.urlPostComponentes}/${data.id}`).subscribe(
              (res: BaseResponse<GenericResponse>) => {

                this.recargarTablaComponentes.emit()
                this.inicializarCampos()

                if (res['code'] == 0) {
                  if ($event.length == 1) {
                    this.message.closeLoading()
                    this.message.SuccessToast('Componente elminado correctamente')
                  } else {
                    this.message.closeLoading()
                    this.message.SuccessToast('Componentes elminados correctamente')
                  }
                } else {
                  this.message.closeLoading()
                  this.message.Error('Error!', `Código: ${res['code']} - Mensaje : ${res['code']}`)
                }
              },

              err => {
                this.message.closeLoading()
                this.message.Error('Error!', err.message)
              })

          });
        } else {
          this.recargarTablaComponentes.emit()
        }
      }
    )

  }

  seleccionadosComponentes($event: MatSelectChange) {
    //console.log($event)
    if ($event.value > 0) {
      this.dialog.open(ModalEquipmentComponent, {
        width: '80%',
        height: '80%',
        data: { action: 'addComponentes', componentsNumber: $event.value }
      }).afterClosed().subscribe(res => {
        //console.log("respuesta", res)
        if (res != undefined) {
          this.formComponentes = res
        } else {
          this.message.Error('Error', "Componentes no identificados")
        }
      })
    }
  }

  clickFilaComponentes($event: ComponentEquipment) {
    let sizeW: number = screen.width > 800 ? 40 : 90
    let sizeH: number = screen.height > 500 ? 55 : 90


    this.dialog.open(ModalEquipmentComponent, {
      width: `${sizeW}%`,
      height: `${sizeH}%`,
      data: {
        action: 'editComponente',
        componentId: $event.id
      }
    }).afterClosed().subscribe(res => {
      this.recargarTablaComponentes.emit()
      this.inicializarCampos()
    })
  }

  ngOnDestroy() {
  }
}
